const SEA_PROGRAMA_EDUCATIVO = [
  { _id: 1, label: "Administración" },
  { _id: 2, label: "Contaduría" },
  { _id: 3, label: "Derecho" },
  { _id: 4, label: "Pedagogía" },
  { _id: 5, label: "Sociologia" },
];

const SEA_REGION = [
  { _id: 1, label: "Coatzacoalcos" },
  { _id: 2, label: "Orizaba" },
  { _id: 3, label: "Poza Rica" },
  { _id: 4, label: "Veracruz" },
  { _id: 5, label: "Xalapa" },
];
const SEA_TRIMESTRE = [
  { _id: 1, label: "1 Trimestre" },
  { _id: 2, label: "2 Trimestre" },
  { _id: 3, label: "3 Trimestre" },
  { _id: 4, label: "4 Trimestre" },
];

export { SEA_PROGRAMA_EDUCATIVO, SEA_REGION, SEA_TRIMESTRE };
